'use client';

import { Suspense, memo } from 'react';
import dynamic from 'next/dynamic';
import { LoadingSpinner } from './LoadingSpinner';
import { STLViewerProps } from './types';

// Dynamically import the STLViewer component with no SSR
const STLViewer = dynamic(() => import('./STLViewer').then(mod => mod.default), {
  ssr: false,
  loading: () => <LoadingSpinner />,
});

function DynamicSTLViewerComponent(props: STLViewerProps) {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <STLViewer {...props} />
    </Suspense>
  );
}

// Memoize the component to prevent unnecessary re-renders
export default memo(DynamicSTLViewerComponent);
